import api from '@app/api'

import type { AblePaginatedResponseFn } from '@app/api/dtos'
import type { GetMonitoringListsPromoParams } from './types'
import type { MonitoringListsPromoDto } from './dtos'

const URL = '/monitoring-lists/promo/'

export const getMonitoringListsPromo: AblePaginatedResponseFn<
GetMonitoringListsPromoParams,
MonitoringListsPromoDto
> = async params => {
  const response = await api.get(URL, { params })
  return response.data
}
